//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Routing.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[[0,"CurrentTile",1,1],[0,"DefaultStockStyle",1,0],[0,"DeleteOverstock",1,0],[0,"SpaceReservationMode",1,0],[0,"SpaceReservationTranslucency",1,0],[0,"StockAnchor",1,0],[0,"StockFolder",1,0],[0,"StockMode",1,0]],[[["stock_part","data_charx"],"SetDefaultStock",{},2,0],[["stock_part","data_charx"],"GetDefaultStock",{},0,0],[["stock_part","data_charx"],"SetPreferredFillerStock",{},2,0],[["stock_part","data_charx"],"GetPreferredFillerStock",{},0,0],[["stock_part","data_charx"],"SetPreferredSpaceReservation",{},2,0],[["stock_part","data_charx"],"GetPreferredSpaceReservation",{},0,0],[["stock_part","data_charx"],"SetPreferredOverstock",{},2,0],[["stock_part","data_charx"],"GetPreferredOverstock",{},0,0]],[]];
SPLM.Preferences.RoutingStock = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingStock";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingStock.StockModeFlag = Object.freeze({
    "LegacyStock" : "LegacyStock", "StockAsComponent" : "StockAsComponent"});

SPLM.Preferences.RoutingStock.SpaceReservationModeFlag = Object.freeze({
    "LegacySpaceReservation" : "LegacySpaceReservation", "SpaceReservationAsComponent" : "SpaceReservationAsComponent"});

export default SPLM;